function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityStatusUpdate = function SvgActivityStatusUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.9 14.9h-.2a1.082 1.082 0 0 1-.5-.4L-.3 9.9A1.3 1.3 0 0 1-.6 9a1.124 1.124 0 0 1 .3-.8c.1-.2.3-.2.4-.3a3.536 3.536 0 0 1 .6-.1 1.649 1.649 0 0 1 .6.5l1.6 2.1V1.3A1.149 1.149 0 0 1 3.5.2a1.026 1.026 0 0 1 .8 0 1.149 1.149 0 0 1 .6 1.1v9.3l1.6-2.2a1.007 1.007 0 0 1 .6-.4 1.146 1.146 0 0 1 .6 0 1.076 1.076 0 0 1 .5.4 1.232 1.232 0 0 1 .2.7 1.207 1.207 0 0 1-.3.8l-3.5 4.6a1.38 1.38 0 0 1-.4.3 1.007 1.007 0 0 1-.3.1z",
    "data-name": "Path 11828",
    style: {
      fill: "#4da5b5"
    },
    transform: "rotate(-90 6.447 2.856)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.3-.3h.2c.3 0 .4.3.5.4l3.5 4.6a1.207 1.207 0 0 1 .3.8 1.124 1.124 0 0 1-.3.8c-.2.2-.3.3-.4.3a3.536 3.536 0 0 1-.6.1 1.007 1.007 0 0 1-.6-.4l-1.6-2.1v9.1a1.149 1.149 0 0 1-.6 1.1 1.026 1.026 0 0 1-.8 0 1.149 1.149 0 0 1-.6-1.1V4l-1.6 2.2a1.007 1.007 0 0 1-.6.4 1.146 1.146 0 0 1-.6 0 1.076 1.076 0 0 1-.5-.4 1.232 1.232 0 0 1-.2-.7 1.207 1.207 0 0 1 .3-.8L-8 .1c.1-.1.2-.3.4-.3a.367.367 0 0 1 .3-.1z",
    "data-name": "Path 11829",
    style: {
      fill: "#4da5b5"
    },
    transform: "rotate(-90 6.447 2.856)"
  }));
};
export default SvgActivityStatusUpdate;